module.exports = __webpack_public_path__ + "img/advertise003.b64c49af.png";